// src/app/features/services/connected-user.service.ts
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { User } from '../models/user.type';

@Injectable({
  providedIn: 'root' // Service is provided at the root level
})
export class UserService {
  // Mock user data
  private mockUser: User = {
    id: 1,
    name: 'Jawher zagrouba',
    photo: 'https://via.placeholder.com/150', // Replace with a valid image URL
    favoriteSnacks: [
      { id: 1, name: 'superAdmin' },
      { id: 2, name: 'read' },
      { id: 3, name: 'write' }
    ]
  };

  constructor() {}

  // Method to fetch user data (returns mock data)
  getUser(): Observable<User> {
    return of(this.mockUser); // Using 'of' to create an Observable from the mock data
  }

  // Method to update user profile (simulated)
  updateUser(user: User): Observable<User> {
    // In a real application, you might want to update the user data on the server
    this.mockUser = { ...this.mockUser, ...user }; // Update the mock data
    return of(this.mockUser); // Return the updated user as an Observable
  }
}
